//Libraries
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

// Components

/**********
 ** Component: Greeting
 ** @type: functional stateless component
 ** @description: Greeting title and description
 **********/
const Greeting = props => (
  <Wrapper id="greeting">
    <h1 className="greeting__title">{`${props.greeting}`}</h1>
  </Wrapper>
);

const Wrapper = styled.div`
  width: 100%;
  text-align: left;

  .greeting {
    &__title,
    &__description {
      color: ${props => props.theme.white};
    }
    &__title {
      font-size: ${rem('32px')};
      font-weight: 600;
      line-height: 1;
      margin-bottom: ${rem('8px')};

      @media ${props => props.theme.breakpointMedium} {
        font-size: ${rem('48px')};
      }

      @media ${props => props.theme.breakpointLarge} {
        font-size: ${rem('56px')};
      }
    }

    &__description {
      font-size: ${rem('16px')};
      font-weight: 300;
      line-height: 1.33333333;
      margin-bottom: 0;

      @media ${props => props.theme.breakpointMedium} {
        font-size: ${rem('18px')};
      }
    }
  }
`;

export default Greeting;



// WEBPACK FOOTER //
// ./src/pages/login/greeting.jsx